export enum UserType {
  COURT_STAFF = "court_staff",
  ADMIN = "admin",
  INDIVIDUAL = "individual",
  COMPANY = "company",
}
